import styled from "styled-components";

export const ASMC = styled.div`
  padding: 0.6rem;
`;

export const ASMWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
